export const openModal = () => {
    return {
        type: 'OPEN_MODAL_ADD_TASK'
    };
};

export const closeModal = () => {

    return {
        type: 'CLOSE_MODAL_ADD_TASK'
    };
};

export const onSuccessAddTask = () => {
    return {
        type: 'SUCCESS_ADD_TASK'
    };
};

export const resetSuccessAddTask = () => {

    return {
        type: 'RESET_SUCCESS_ADD_TASK'
    };
};

export const refreshTableTimeSheetToggle = (value: boolean) => {
    return {
        payload: value,
        type: 'REFRESH_TABLE_TIMESHEET_TOGGLE'
    };
}